import React from 'react';
import { CheckSquare, Square } from 'lucide-react';

// List of scanned images with per-image selection checkboxes.
const DetectedImagesList = ({
  images,
  selectedUrls,
  allSelected,
  onToggleSelected,
  onToggleSelectAll,
}) => (
  <div className="mb-4 border border-hairline rounded-lg">
    <div className="p-3 border-b border-hairline flex items-center justify-between">
      <div className="text-sm font-semibold text-ink">Detected Images ({images.length})</div>
      <button type="button" onClick={onToggleSelectAll} disabled={images.length === 0} className="text-sm text-accent disabled:text-muted inline-flex items-center gap-1">
        {allSelected ? <CheckSquare size={14} /> : <Square size={14} />}
        {allSelected ? 'Deselect all' : 'Select all'}
      </button>
    </div>
    <div className="max-h-[420px] overflow-auto p-2 space-y-2">
      {images.length === 0 ? (
        <div className="text-sm text-muted p-2">No images yet. Enter URL and scan.</div>
      ) : images.map((img, index) => (
        <label key={`${img.url}-${index}`} className="flex items-center gap-2 p-2 hover:bg-surface-2 rounded cursor-pointer">
          <input
            type="checkbox"
            checked={selectedUrls.includes(img.url)}
            onChange={() => onToggleSelected(img.url)}
          />
          <img src={img.url} alt={img.alt || `Image ${index + 1}`} className="w-14 h-14 object-cover rounded border border-hairline bg-surface-2" />
          <div className="min-w-0">
            <div className="text-sm text-ink truncate">{img.alt || `Image ${index + 1}`}</div>
            <div className="text-xs text-muted truncate">{img.url}</div>
            <div className={`text-[11px] ${img.selected !== false ? 'text-positive' : 'text-warn'} truncate`}>
              {img.selection_reason || (img.selected !== false ? 'selected' : 'deselected')}
            </div>
          </div>
        </label>
      ))}
    </div>
  </div>
);

export default DetectedImagesList;
